// @flow
import type { InnerOption } from '../Select'
import _ from 'lodash'
import type { GroupedOptionType, OptionType } from '../../types'

export function innerOptions(
  options: Array<OptionType>,
  groupedOptions: ?Array<GroupedOptionType>
): Array<InnerOption> {
  return _.concat(
    regularInnerOptions(options),
    groupedOptions ? groupedInnerOptions(groupedOptions) : []
  )
}

export function flatInnerOptions(
  options: Array<OptionType>,
  groupedOptions: ?Array<GroupedOptionType>
): Array<InnerOption> {
  return _.concat(
    regularInnerOptions(options),
    groupedOptions ? flattenGroupedInnerOptions(groupedOptions) : []
  )
}

function regularInnerOptions(options: Array<OptionType>): Array<InnerOption> {
  return _.map(options, (option) => toInnerOption(option))
}

function groupedInnerOptions(options: Array<GroupedOptionType>): Array<InnerOption> {
  return _.map(options, (option) => {
    return {
      label: option.name,
      options: _.map(option.options, (o) => toInnerOption(o))
    }
  })
}

function flattenGroupedInnerOptions(options: Array<GroupedOptionType>): Array<InnerOption> {
  return _.flatten(
    _.map(options, (option) => {
      return _.map(option.options, (o) => toInnerOption(o))
    })
  )
}

function toInnerOption(option: OptionType): InnerOption {
  return { value: option.id, label: option.name }
}
